"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _laboratoryLib = require("laboratory-lib");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _UpgradeProductProperties = _interopRequireDefault(require("self-service-api/constants/UpgradeProductProperties"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _TrialPropsInterface = require("ui-addon-upgrades/_core/trial/TrialPropsInterface");

var _AdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/AdminOnlyWrapper"));

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

var _TrialActivationModalContainer = _interopRequireDefault(require("../common/components/TrialActivationModalContainer"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var CLICK_DELAY = 50;
var GROUP_PARAMETER_OPTIONS = ['control', 'variation'];
var treatmentKey = 'revenue-retention-mon339';

function sequence() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(void 0, args);
    });
  };
}

var TrialActivationButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TrialActivationButton, _Component);

  function TrialActivationButton() {
    var _this;

    (0, _classCallCheck2.default)(this, TrialActivationButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrialActivationButton).call(this));

    _this.handleClick = function () {
      var upgradeData = _this.props.upgradeData;
      tracker.track('trialActivationButtonInteraction', (0, _extends2.default)({
        action: 'clicked'
      }, upgradeData));

      _this.setState({
        showActivationModalContainer: true
      });
    };

    _this.state = {
      showActivationModalContainer: false,
      mon339Treatment: null
    };
    _this.debouncedHandleClick = (0, _utils.debounce)(_this.handleClick, CLICK_DELAY);
    return _this;
  }

  (0, _createClass2.default)(TrialActivationButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var upgradeData = this.props.upgradeData;
      tracker.track('trialActivationButtonInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, upgradeData));

      if (upgradeData.upgradeProduct === _UpgradeProducts.REPORTING) {
        var treatmentRequest = (0, _laboratoryLib.createTreatmentRequest)(treatmentKey, _PortalIdParser.default.get());

        _noAuthApiClient.default.get(treatmentRequest.url).then(function (treatment) {
          return treatment.parameters;
        }).then(function (parameters) {
          var group = (0, _laboratoryLib.getParameter)(parameters, 'group', GROUP_PARAMETER_OPTIONS).value;

          _this2.setState({
            mon339Treatment: group
          });
        }).catch(function (error) {
          _this2.setState({
            mon339Treatment: 'control'
          });

          if (window.Raven) {
            window.Raven.captureMessage('MON339 treatment fetch failed', {
              extra: {
                error: error
              }
            });
          }
        }).done();
      } else {
        this.setState({
          mon339Treatment: 'control'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$upgradeDa = _this$props.upgradeData,
          trialId = _this$props$upgradeDa.trialId,
          upgradeProduct = _this$props$upgradeDa.upgradeProduct,
          upgradeData = _this$props.upgradeData,
          onClick = _this$props.onClick,
          shouldHideSurvey = _this$props.shouldHideSurvey,
          onSuccess = _this$props.onSuccess,
          successModalHeader = _this$props.successModalHeader,
          successModalSubText = _this$props.successModalSubText,
          successModalCtaText = _this$props.successModalCtaText,
          showSuccessModalIllustration = _this$props.showSuccessModalIllustration;
      var _this$state = this.state,
          showActivationModalContainer = _this$state.showActivationModalContainer,
          mon339Treatment = _this$state.mon339Treatment;
      var onClickSequence = sequence(this.debouncedHandleClick, onClick);
      var propsToPass = (0, _utils.omit)(this.props, ['onClick', 'upgradeData', 'onSuccess', 'shouldHideSurvey', 'trialId', 'allowModal', 'successModalHeader', 'successModalSubText', 'successModalCtaText', 'showSuccessModalIllustration']);
      if (!trialId) return null; // MON339

      if (!mon339Treatment) return null;
      return _react.default.createElement(_react.default.Fragment, null, showActivationModalContainer && _react.default.createElement(_TrialActivationModalContainer.default, {
        upgradeData: upgradeData,
        shouldHideSurvey: shouldHideSurvey,
        onSuccess: onSuccess,
        successModalHeader: successModalHeader,
        successModalSubText: successModalSubText,
        successModalCtaText: successModalCtaText,
        showSuccessModalIllustration: showSuccessModalIllustration,
        mon339Treatment: mon339Treatment
      }), _react.default.createElement(_AdminOnlyWrapper.default, {
        adminType: _AdminTypes.TEAM,
        modalType: upgradeProduct === _UpgradeProducts.TEMPORARY_REMOTE_TOOLS ? _AdminModalTypes.REQUEST_REMOTE_TOOLS : _AdminModalTypes.REQUEST_TRIAL,
        merchandiseId: _UpgradeProductProperties.default[upgradeProduct].merchandiseId
      }, propsToPass.use && propsToPass.use.includes('link') ? _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.trialActivationButton." + (mon339Treatment === 'variation' ? 'mon339Reporting' : upgradeProduct)
      })) : _react.default.createElement(_UILoadingButton.default, (0, _extends2.default)({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true,
        loading: showActivationModalContainer
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.trialActivationButton." + (mon339Treatment === 'variation' ? 'mon339Reporting' : upgradeProduct)
      }))));
    }
  }]);
  return TrialActivationButton;
}(_react.Component);

TrialActivationButton.defaultProps = {
  use: 'primary',
  onClick: function onClick() {}
};
TrialActivationButton.propTypes = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _TrialPropsInterface.TrialActivationButtonPropsInterface, {
  onClick: _propTypes.default.func
});
var _default = TrialActivationButton;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/trial/TrialActivationButton.js
// module id = 739
// module chunks = 5 6